import { render, staticRenderFns } from "./HandleFile.vue?vue&type=template&id=a6e690ce&"
import script from "./HandleFile.vue?vue&type=script&lang=js&"
export * from "./HandleFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports